<template>
<div class="cart-table">
    <h3 class="cart-table__title" v-if="showTitle">
        <span v-if="index && outlet">Заказ - {{ outletStatus }}</span>
        <span v-if="orderNumber">
          Номер заказа: {{ orderNumber }}
          <span v-if="outletStatus"> - {{ outletStatus }}</span>
        </span>
    </h3>
    <div class="cart-table__head">
        <div class="cart-table__head-cell cart-table__head-name">Товары</div>
        <div class="cart-table__head-cell cart-table__head-amount">Кол-во</div>
        <div class="cart-table__head-cell cart-table__head-price">Цена</div>
        <div class="cart-table__head-cell cart-table__head-sum">Сумма</div>
    </div>

    <div class="cart-table__body">
        <div v-for="item in relevantBasketItems" :key="item.id">
            <basket-item :item="item" :read-only="readOnly">

            </basket-item>
        </div>

        <template v-if="showCoupons">
            <div class="cart-table__row" v-for="(appliedCoupon, i) in appliedCoupons" :key="i">
                <span>Промокод <b>{{ appliedCoupon }}</b></span>
                <button class="cart-table__remove" type="button" title="Удалить" v-on:click="removeCoupon(appliedCoupon)" v-if="!finish">
                    <svg class="icon icon--close_sm">
                        <use xlink:href="#icon-close_sm"></use>
                    </svg>
                </button>
            </div>
        </template>
    </div>

    <div class="cart-table__additional container-tablet-lg" v-if="!finish && !appliedCoupons.length && showCoupons">
        <div class="cart-table__promocode" v-if="!readOnly">
            <div class="field field--promocode cart-table__promocode-field">
                <label class="field__label" for="field-promocode">Промокод</label>
                <input class="field__input" :class="this.coupon.class" type="text" name="promocode" id="field-promocode" v-model="couponValue" v-on:input="onInputCoupon()">
            </div>
            <button class="btn btn--blue cart-table__promocode-submit" type="button" v-on:click="onAddCoupon()">ОК</button>
        </div>
        <div class="cart-table__promocode-note validation-error-cart" v-if="!readOnly && this.coupon.error">
            <span v-html="this.coupon.error"></span>
        </div>
        <div class="cart-table__promocode-note" v-if="!readOnly">
            При оформлении заказа вы можете использовать только <a href="/customers/?faq=524">один промокод</a>
        </div>
    </div>

  <p v-if="listCount - maxCount > 0" class="cart-table__outlet-min-price">
    * Максимальное количество для заказа {{ maxCount }}шт. Уберите из заказа {{ listCount - maxCount }}шт.
  </p>
  <p v-if="outlet && (outletMinPrice - listPrice) > 0 " class="cart-table__outlet-min-price">
    * мин {{outletMinPrice}} руб, добавьте ещё на {{outletMinPrice - listPrice}} руб или удалите
  </p>

  <div class="cart__free-delivery-left" v-if="listPrice < freeDeliverySum">
    Закажите еще товары на сумму {{ getFixedNumber(freeDeliverySum - listPrice, 2) }} {{ pluralForm((freeDeliverySum - listPrice), ['рубль', 'рубля', 'рублей']) }} для доставки со скидкой (2–14  руб.)
    <a :href.prop="listUrl" p="outlet" class="btn btn--blue">
      Смотреть другие товары
    </a>
  </div>
</div>
</template>

<script>
    import basketItem from "./basketItem.vue";
    import {mapState, mapActions} from 'vuex';
    import {pluralForm} from "../../../scripts/helpers";

    export default {
        name: "basket-item-list",
        components: {basketItem},
        props: {
            readOnly: Boolean,
            finish: Boolean,
            outlet: String|Number,
            index: Number,
            orderNumber: Number,
            showCoupons: Boolean,
            showTitle: Boolean,
            freeDeliverySum: Number,
        },
        data() {
            return {
                'couponValue': '',
            }
        },
        methods: {
            ...mapActions(['addCoupon', 'removeCoupon', 'updateCouponError']),
            onAddCoupon() {
                let self = this;
                this.addCoupon(this.couponValue).then((coupon) => {
                    self.couponValue = coupon;
                });
            },
            onInputCoupon() {
                this.updateCouponError('');
            },
            pluralForm
        },
        computed: {
            ...mapState(["basketItems", "outletMinPrice", "maxCount", "appliedCoupons", "coupon"]),

            relevantBasketItems() {
                return this.basketItems
                        .filter(basketItem => basketItem.outlet === this.outlet)
            },
            outletStatus() {
                return this.relevantBasketItems.slice(0, 1)[0].status;
            },
            listPrice() {
              let price = 0;
              this.relevantBasketItems.map((item)=> {
                price += 1 * item.finalPrice;
              });
              return price;
            },
            listCount() {
              let count = 0;
              this.relevantBasketItems.map((item)=> {
                count += item.finalPrice>0 ? 1 * item.qnt : 0;
              });
              return count;
            },
            listUrl() {
                return this.outlet ? '/outlet/' : '/catalog/';
            },
            getFixedNumber() {
                return (value, fixedValue) => {
                    return parseFloat((value).toFixed(fixedValue));
                }
            }
        }
    }
</script>
